import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { InspectLineResult } from "@/model/InspectLineResult";
import { deepCopy } from "@/service/util";

export interface InspectLineState {
  inspectLineList: InspectLineResult[];
  sideSlipValue: number | null;
  speedMeterValue: number | null;
  dieselValue: number | null;
}

const initialState: InspectLineState = {
  inspectLineList: [],
  sideSlipValue: null,
  speedMeterValue: null,
  dieselValue: null
};

const actions: ActionTree<InspectLineState, any> = {
  setState(
    { commit }: ActionContext<InspectLineState, any>,
    payload: InspectLineResult[]
  ): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<InspectLineState, any>): void {
    commit("clearState");
  },
  setSideSlip(
    { commit }: ActionContext<InspectLineState, any>,
    payload: number
  ): void {
    commit("setSideSlip", payload);
  },
};

const mutations = {
  setState(state: InspectLineState, payload: InspectLineResult[]) {
    if (payload && payload.length > 0) {
      state.inspectLineList = payload;
      state.sideSlipValue = payload[0].inspectValue;
      state.speedMeterValue = payload[4].inspectValue;
      if (payload.length >= 12) {
        state.dieselValue = payload[11].inspectValue;
      }
    }
  },
  clearState(state: InspectLineState) {
    Object.assign(state, deepCopy(initialState));
  },
  setSideSlip(state: InspectLineState, payload: number) {
    state.sideSlipValue = payload;
  }
};

const getters: GetterTree<InspectLineState, any> = {
  inspectLineList(state: InspectLineState): InspectLineResult[] {
    return state.inspectLineList;
  },
  sideSlipValue(state: InspectLineState) {
    return state.sideSlipValue;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: deepCopy(initialState),
  getters,
  actions,
  mutations
};
